<template>
  <MainLayout>
    <div class="subscriptions-main">
      <LayoutSection size="o5v90">
        <el-row>
          <el-col>
            <div class="text-left pt-50 title">
              <h2>{{ $t("membre.title") }}</h2>
            </div>
          </el-col>
        </el-row>
        <el-row class="alt-section">
          <el-col :xs="24" :sm="24" :md="{ span: 13, offset: 2 }" class="img">
            <div class="text-center">
              <img :src="image.tel" class="telphone-image" />
            </div>
          </el-col>
          <el-col class="description" :xs="24" :sm="24" :md="9">
            <h2 class="text-left mb-20 member-section-1">
              {{ $t("membre.section1.heading") }}
            </h2>
            <p>
              {{ $t("membre.section1.description") }}
            </p>
          </el-col>
        </el-row>
        <el-row class="alt-section">
          <el-col
            class="description"
            :xs="24"
            :sm="24"
            :md="{ span: 9, offset: 3 }"
          >
            <h2 class="text-left mb-20 member-section-1">
              {{ $t("membre.section2.heading") }}
            </h2>
            <p>
              {{ $t("membre.section2.description") }}
            </p>
          </el-col>
          <el-col :xs="24" :sm="24" :md="9" class="img">
            <div class="text-center">
              <img :src="image.wine" class="telphone-image" />
            </div>
          </el-col>
        </el-row>
        <el-row class="alt-section">
          <el-col :xs="24" :sm="24" :md="{ span: 13, offset: 2 }" class="img">
            <div class="text-center">
              <img :src="image.prices" class="prices-image" />
            </div>
          </el-col>
          <el-col class="description" :xs="24" :sm="24" :md="9">
            <h2 class="text-left mb-20 member-section-1">
              {{ $t("membre.section3.heading") }}
            </h2>
            <p>
              {{ $t("membre.section3.description") }}
            </p>
          </el-col>
        </el-row> 
        <el-row class="alt-section section-appointment">
          <el-col
            class="description"
            :xs="24"
            :sm="24"
            :md="{ span: 9, offset: 3 }"
          >
          <h2 class="text-left mb-20 member-section-1">
              {{ $t("membre.section4.heading") }}
          </h2>
          <p>
            {{ $t("membre.section4.description") }}
          </p>
          </el-col>
          <el-col :xs="24" :sm="24" :md="9" class="img">
            <div class="text-center">
              <img :src="image.appointment" class="appointment-image" />
            </div>
          </el-col>          
        </el-row>
        <el-row class="alt-section">
          <el-col :xs="24" :sm="24" :md="{ span: 13, offset: 2 }" class="img">
            <div class="text-center">
              <img :src="image.event" class="event-image" />
            </div>
          </el-col>
          <el-col class="description" :xs="24" :sm="24" :md="9">
            <h2 class="text-left mb-20 member-section-1">
              {{ $t("membre.section5.heading") }}
            </h2>
            <ul class="text-left pl-18">
              <li
                v-for="(value, index) in $t('membre.section5.list')"
                :key="index"
              >
                {{ value }}
              </li>
            </ul>
          </el-col>
          
        </el-row>
      </LayoutSection>
      <el-row class="mt-100">
        <el-col class="mb-40">
          <h4 class="become-member">{{ $t("membre.andMuchMore") }}</h4>
        </el-col>
        <el-col class="bg-accent-light pt-50 pb-50">
          <h2 class="pb-15 become-member-title">{{ $t("membre.becomeMember") }}</h2>
          <p
            class="text-center pb-15"
            v-html="priceFormat($t('membre.plan')) + $t('membre.year')"
          ></p>
          <el-button type="primary" class="subscribe">
            {{ $t("membre.subscribe") }}
          </el-button>
        </el-col>
      </el-row>
    </div>
  </MainLayout>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { formatCurrency, specialFormatCurrency } from "@/utils/common-utils";

import MainLayout from "@/components/layout/main-layout.vue";
import LayoutSection from "@/components/layout/layout-section.vue";
import wine from "@/assets/images/membre/wine.png";
import prices from "@/assets/images/membre/prices.png";
import appointment from "@/assets/images/membre/appointment.png";
import eventsimg from "@/assets/images/membre/event.png";
import tel from "@/assets/images/membre/tel.png";

export default {
  components: {
    MainLayout,
    LayoutSection,
  },
  data() {
    return {
      title: "Subscriptions",
      image: {
        tel: tel,
        wine: wine,
        appointment: appointment,
        event: eventsimg,
        prices: prices,
      },
    };
  },
  computed: {
    ...mapState("subscription", ["subscriptions"]),
  },
  methods: {
    ...mapActions("subscription", ["fetchSubscriptions"]),
    getSubscriptions() {
      this.fetchSubscriptions({});
    },
    goToPreviousPage() {
      this.$router.go(-1);
    },
    priceFormat(price) {
      if (this.$i18n.locale == "fr-CA" || this.$i18n.locale == "en-US") {
        var formatPrice = specialFormatCurrency(price, this.$i18n.locale);
        if (this.$i18n.locale == "en-US") {
          formatPrice = formatPrice.split(".");
        } else {
          formatPrice = formatPrice.split(",");
        }
        if (formatPrice.length == 1) {
          formatPrice.push("00");
        }
        return `${
          formatPrice[0]
        }<sup style="font-size: 10px; line-height: 0; vertical-align: 5px;"> ${formatPrice[1]
          .toString()
          .padEnd(2, "0")}</sup> $`;
      }
      return formatCurrency(price, this.$i18n.locale);
    },
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/variables.scss";
.previousBtn {
  .el-button--text {
    color: #a31c25;
    cursor: pointer;
    font-weight: 500 !important;
  }
  .previousBtn {
    color: $color-primary;
    cursor: pointer;
    padding-bottom: 20px;
  }
  .el-button:hover {
    text-decoration: underline;
  }
}
.become-member {
  font-family: $font-family-futura-std;
}
.become-member-title {
  font-family: $font-family-bold-condensed;
  font-size: 20px;
}
</style>